export default "__VITE_ASSET__3fc7940c__"